import React, {useEffect, useRef, useState} from 'react';
import LazyImage from "../../Common/LazyImage";
import CardImage from "./CardImage";
import CardDetails from "../../Cardetails/CardDetails";
import Search from "../../Search/Search";
import Filter from "../../Search/Filter";
import "./Cards.css";
import { useAuth } from "../../../AuthContext";
import {Dropdown} from "react-bootstrap";
import {BrowserView, MobileView} from "react-device-detect";


const Cards = ({ cardsData = { cards: [], editions: [], types: [], subtypes: [], abilities: [], rarities: [] }, deckView, cAbilities, isCollection, toggleCardSelection, saveCollection, selectedCards, setSelectedCards, userCollection }) => {
    const [selectedCard, setSelectedCard] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    // Derive published edition names from the editions payload (server should provide only published editions)
    const publishedEditionNames = Array.isArray(cardsData.editions) ? cardsData.editions.map(e => (e && e.name ? e.name : e).toString().toLowerCase()) : [];

    // Initialize filteredCards only with cards that belong to published editions
    const [filteredCards, setFilteredCards] = useState(Array.isArray(cardsData.cards) ? cardsData.cards.filter(card => Array.isArray(card.edition) ? card.edition.some(ed => publishedEditionNames.includes(String(ed).toLowerCase())) : publishedEditionNames.includes(String(card.edition).toLowerCase())) : []);
    const [abilities, setAbilities] = useState(Array.isArray(cardsData.abilities) ? cardsData.abilities : []);
    const [dAbilities, setDAbilities] = useState(cAbilities);
    const { showFilter, setShowFilter, host, port, user } = useAuth();
    const [appliedFilters, setAppliedFilters] = useState({});
    const filtersParam = { "editions": cardsData.editions, "types": cardsData.types, "subtypes": cardsData.subtypes, "abilities": cardsData.abilities, "rarities": cardsData.rarities }
    const [selectedEdition, setSelectedEdition] = useState('All');
    const [filters, setFilters] = useState({});const isFilterApplied = Object.keys(filters).length > 0;
    const barRef = useRef(null);
    const [maxButtons, setMaxButtons] = useState(0);

    // Keep CSS variable --topbar-height in sync with the actual top bar height
    useEffect(() => {
        if (!barRef.current || typeof window === 'undefined') return;
        const el = barRef.current;
        // Initial set
        const setHeight = () => {
            const h = el.offsetHeight || 0;
            try { document.documentElement.style.setProperty('--topbar-height', h + 'px'); } catch(e){}
        };
        setHeight();
        // Resize observer to handle dynamic content inside the top bar
        let ro = null;
        try {
            ro = new ResizeObserver(() => setHeight());
            ro.observe(el);
        } catch (e) { /* ignore */ }
    }, [selectedCard]);
    const scrollRight = () => {
        document.querySelector('.edition-filter').scrollLeft += 100; // Scrolls by 100px; adjust as needed
    };


    const SvgFilters = () => (
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" style={{ height: 0, width: 0, position: 'absolute' }}>
            <defs>
                <filter id="shadow" height="130%">
                    <feDropShadow dx="2" dy="2" stdDeviation="2" floodColor="black" />
                </filter>
            </defs>
        </svg>
    );

    // Fonction pour réinitialiser tous les filtres
    const resetFilters = () => {
        setFilters({});
    };





    const filterByEdition = (edition) => {
        setSelectedEdition(edition);
        const filters = { ...appliedFilters, edition: [edition] };
        applyFilters(filters, searchTerm);
    };

    const filterAll = () => {
        setSelectedEdition('All');
        const filters = { ...appliedFilters };
        delete filters.edition; // Supprimer le filtre par édition
        applyFilters(filters, searchTerm);
    };

    const showCardDetails = (cardId) => {
        const selected = filteredCards.find((card) => card._id === cardId);
        setSelectedCard(selected);
    };

    const hideCardDetails = () => {
        setSelectedCard(null);
    };

    const handleSearch = (searchTerm) => {
        setSearchTerm(searchTerm);

        const filtered = Array.isArray(cardsData.cards) ? cardsData.cards.filter((card) =>
            card.name.toLowerCase().includes(searchTerm.toLowerCase())
        ) : [];
        setFilteredCards(filtered);
    };

    const toggleFilter = () => {
        setShowFilter(!showFilter);
    };

    function setActive(selectedButton) {
        document.querySelectorAll('.edition-button').forEach(button => {
            button.classList.remove('active');
        });

        if (selectedButton && selectedButton.classList) selectedButton.classList.add('active');
    }

    const applyFilters = (filters, searchTerm) => {
        setAppliedFilters(filters);

        // If caller passed a searchTerm param, copy it into filters to unify handling below
        if (searchTerm) {
            try { filters.searchTerm = searchTerm; } catch (e) { /* ignore */ }
        }

        // Filtrer les cartes en fonction des filtres appliqués
        // Start from cards that belong to published editions only
        let filtered = Array.isArray(cardsData.cards) ? cardsData.cards.filter(card => {
            if (!Array.isArray(card.edition)) return publishedEditionNames.includes(String(card.edition).toLowerCase());
            return card.edition.some(ed => publishedEditionNames.includes(String(ed).toLowerCase()));
        }) : [];

        if (filters.searchTerm) {
            const searchText = filters.searchTerm.toLowerCase();
            filtered = filtered.filter((card) =>
                card.name.toLowerCase().includes(searchText) ||
                card.types.some((type) => type.toLowerCase() === searchText) ||
                card.edition.some((edition) => edition.toLowerCase() === searchText) ||
                card.subtypes.some((subtype) => subtype.toLowerCase() === searchText) ||
                card.summonerSkills.some((skill) => skill.skill.toLowerCase().includes(searchText)) ||
                card.baseEffects.some((effect) => effect.effect.toLowerCase().includes(searchText)) ||
                card.baseEffects.some((effect) => effect.effectDetail.toLowerCase().includes(searchText)) ||
                card.actions.some((action) => action.tossOfCoin.some((toss) => toss.success.description.toLowerCase().includes(searchText))) ||
                card.actions.some((action) => action.tossOfCoin.some((toss) => toss.success.detail.toLowerCase().includes(searchText))) ||
                card.actions.some((action) => action.directPurchase.some((purchase) => purchase.action.toLowerCase().includes(searchText))) ||
                card.actions.some((action) => action.directPurchase.some((purchase) => purchase.actionDetail.toLowerCase().includes(searchText)))
            );
        }

        


        if (filters.subtype && Array.isArray(filters.subtype)) {
            const selectedSubtypeTerms = filters.subtype.map((term) => term.trim().toLowerCase());
            filtered = filtered.filter((card) => {
                const cardSubtypes = Array.isArray(card.subtypes) ? card.subtypes : [];
                return selectedSubtypeTerms.some(sel => sel === 'all' || cardSubtypes.some(st => {
                    const terms = String(st || '').toLowerCase().split(' ').map(s => s.trim()).filter(Boolean);
                    return terms.includes(sel);
                }));
            });
        }

        // Edition filter: if present and not 'All', keep only cards that belong to the selected edition(s)
        if (filters.edition && Array.isArray(filters.edition) && filters.edition.length > 0) {
            const selectedEditions = filters.edition.map(e => String(e).toLowerCase());
            if (!selectedEditions.includes('all')) {
                filtered = filtered.filter((card) => {
                    const cardEditions = Array.isArray(card.edition) ? card.edition : [card.edition];
                    return cardEditions.some(ed => selectedEditions.includes(String(ed).toLowerCase()));
                });
            }
        }

        // Update state with the filtered results
        setFilteredCards(filtered);
    };


    const calculateMaxButtons = () => {
        if (barRef.current) {
            const containerWidth = barRef.current.offsetWidth;
            let totalButtonsWidth = 0;
            let maxButtonsCount = 0;

            const buttonElements = barRef.current.querySelectorAll('.edition-button');
            buttonElements.forEach(button => {
                totalButtonsWidth += button.offsetWidth +
                    parseInt(window.getComputedStyle(button).marginLeft, 10) +
                    parseInt(window.getComputedStyle(button).marginRight, 10);
            });

            buttonElements.forEach(button => {
                const buttonWidth = button.offsetWidth +
                    parseInt(window.getComputedStyle(button).marginLeft, 10) +
                    parseInt(window.getComputedStyle(button).marginRight, 10);

                if (totalButtonsWidth <= containerWidth) {
                    maxButtonsCount = buttonElements.length;

                } else if (totalButtonsWidth - buttonWidth < containerWidth) {
                    maxButtonsCount--;
                    totalButtonsWidth -= buttonWidth;
                }
            });

            setMaxButtons(maxButtonsCount);
        }
    };

    // Call calculateMaxButtons on mount and on window resize
    useEffect(() => {
        calculateMaxButtons();
        window.addEventListener('resize', calculateMaxButtons);
        return () => window.removeEventListener('resize', calculateMaxButtons);
    }, []);



    return (
        <div className="card-component parent">
            <MobileView>
                {showFilter ? (
                    <Filter filters={filtersParam} applyFilters={applyFilters} searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}/>
                ) : (
                    <div className="container card-index">
                        <div ref={barRef} className="top-search-bar fixed-top sticky-child bg-transparent">
                            <Search onSearch={handleSearch} toggleFilter={toggleFilter}/>
                            <div className="second-bar d-flex align-items-center mt-2">
                                <div className="edition-filter d-flex mx-auto">
                                    {deckView ===1 ?
                                        "" :
                                        Array.isArray(cardsData.editions) ?
                                            cardsData.editions.map((edition, index) => (
                                                <button
                                                    key={edition.name || index}
                                                    className="edition-button btn mx-1 mx-lg-4"
                                                    onClick={(e) => { filterByEdition(edition.name); setActive(e.target) }}
                                                >
                                                    {edition.name}
                                                </button>
                                            ))
                                        : null

                                    }
                                </div>
                            </div>
                        </div>
                        <div className="row card-list-row scrollable" style={{ paddingTop: '1rem'}}>
                            {/* Render cards based on filteredCards */}
                            {Array.isArray(filteredCards) ?
                                filteredCards.map((card, index) => (
                                    <div key={card._id} className={"col-4 col-md-3 col-lg-2 px-1 mb-2 test"}>
                                        <div key={card._id} className="card-container pl-1 pr-1">
                                            <div style={{position: "relative", width: "fit-content", marginBottom: index === filteredCards.length - 1 ? "4em" : 0}} >
                                                <CardImage
                                                    className="card-img img-fluid mb-0 card-container w-100"
                                                    src={card.imageUrl ? card.imageUrl : `/assets/cards/${(card.card && deckView === 1 ? (Array.isArray(card.card.edition) ? card.card.edition[0] : card.card.edition) : (Array.isArray(card.edition) ? card.edition[0] : card.edition))}/EN/${
                                                        (card.card && deckView === 1 ? card.card.cardNumber : card.cardNumber)
                                                    }_${String(card.name||'').toLowerCase().replace(/ /g, '_')}_en.png`}
                                                    alt={card.name}
                                                    onClick={() => isCollection ? toggleCardSelection(card._id) : showCardDetails(card._id)}
                                                />
                                                {selectedCards?.some((c) => c.card === card._id) && isCollection && toggleCardSelection ?
                                                    <img src={"/assets/icons/check-complete.png"} alt={"Checkmark"}
                                                         style={{
                                                             position: 'absolute',
                                                             top: '25%',
                                                             right: '25%',
                                                             width: '50%'
                                                         }}
                                                         onClick={() => toggleCardSelection(card._id)}
                                                    /> : null
                                                }
                                            </div>
                                            {card.card && deckView === 1 && (
                                                <p className="quantity-inline text-center"
                                                   style={{color: (card.quantity - parseInt(card.card.rank) > 0) ? 'red' : 'lightgrey'}}>{card.quantity}</p>
                                            )}
                                        </div>
                                    </div>
                                ))
                            : null}
                        </div>
                    </div>
                )}
            </MobileView>
            <BrowserView>
                <div className="card-component parent container-fluid browser-view">
                    <div className="row">
                        <div className="col-md-4 col-lg-3 filter"
                             style={{position: "sticky", top: "0", height: "100vh", overflowY: "auto"}}>
                            <BrowserView>
                                <h2 className="mb-3 mt-5 text-white text-center">Filter</h2>
                            </BrowserView>
                            <div ref={barRef} className="top-search-bar bg-transparent text-center d-flex justify-content-center w-100">
                                <Search onSearch={handleSearch} toggleFilter={toggleFilter}/>
                            </div>
                            <div className="second-bar mt-2">
                                <div className="edition-filter text-center">
                                    {deckView === 1 ? "" : (
                                        <>
                                            {Array.isArray(cardsData.editions) ?
                                                cardsData.editions.map((edition, index) => (
                                                    <button
                                                        key={edition.name || index}
                                                        className={`edition-button btn ${selectedEdition === edition.name ? 'btn-secondary active' : 'btn-outline-secondary'}`}
                                                        onClick={() => filterByEdition(edition.name)}
                                                    >
                                                        {edition.name}
                                                    </button>
                                                ))
                                            : null}
                                            <button
                                                className={`edition-button btn ${selectedEdition === 'All' ? 'btn-secondary active' : 'btn-outline-secondary'}`}
                                                onClick={filterAll}
                                            >
                                                All
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className="filter-section mt-3">
                                <Filter filters={filtersParam} applyFilters={applyFilters} searchTerm={searchTerm}
                                        setSearchTerm={setSearchTerm}/>
                            </div>
                        </div>
                        <div className="col-md-9 col-lg-9">
                            <div className="card-index">
                                <div className="row card-list-row scrollable" style={{paddingTop: '1rem', scrollbarWidth: "thin !important"}}>
                                    {Array.isArray(filteredCards) ?
                                        filteredCards.map((card, index) => (
                                        <div key={card._id} className={"col-4 col-md-3 col-lg-2 px-1 mb-2 test"}>
                                            <div key={card._id} className="card-container pl-1 pr-1">
                                                <div style={{
                                                    position: "relative",
                                                    width: "fit-content",
                                                    marginBottom: index === filteredCards.length - 1 ? "4em" : 0
                                                }}>
                                                                     {/* CardImage placeholder removed to avoid duplicate images; the image
                                                                         tag with the proper src is rendered by the logic below. */}

                                                {/* Build image src robustly: if edition is an array, use the first element */}
                                                {/* Inline replacement to avoid duplicating logic between mobile/browser render paths */}
                                                {
                                                    (() => {
                                                        const editionVal = (card.card && deckView === 1)
                                                            ? (Array.isArray(card.card.edition) ? card.card.edition[0] : card.card.edition)
                                                            : (Array.isArray(card.edition) ? card.edition[0] : card.edition);
                                                        const num = (card.card && deckView === 1) ? card.card.cardNumber : card.cardNumber;
                                                        // Prefer server-provided imageUrl when available (it's generated safely on upload)
                                                        if (card.imageUrl) {
                                                            return (
                                                                <CardImage
                                                                    src={card.imageUrl}
                                                                    alt={card.name}
                                                                    className="card-img img-fluid mb-0 card-container w-100"
                                                                    onClick={() => isCollection ? toggleCardSelection(card._id) : showCardDetails(card._id)}
                                                                />
                                                            );
                                                        }
                                                        // Fallback: build a safe filename by removing diacritics and encoding
                                                        const rawName = String(card.name || 'card').toLowerCase();
                                                        // remove combining marks (standard way)
                                                        const safeName = rawName.normalize('NFD').replace(/\p{Diacritic}/gu, '').replace(/\s+/g, '_');
                                                        const fileBase = `${num}_${safeName}`;
                                                        const filename = `${fileBase}_en.png`;
                                                        const src = `/assets/cards/${editionVal}/EN/${encodeURIComponent(filename)}`;
                                                        return (
                                                            <CardImage
                                                                src={src}
                                                                alt={card.name}
                                                                className="card-img img-fluid mb-0 card-container w-100"
                                                                onClick={() => isCollection ? toggleCardSelection(card._id) : showCardDetails(card._id)}
                                                            />
                                                        );
                                                    })()
                                                }

                                                    {selectedCards?.some((c) => c.card === card._id) && isCollection && toggleCardSelection ?
                                                        <img src={"/assets/icons/check-complete.png"} alt={"Checkmark"}
                                                             style={{
                                                                 position: 'absolute',
                                                                 top: '25%',
                                                                 right: '25%',
                                                                 width: '50%'
                                                             }}
                                                             onClick={() => toggleCardSelection(card._id)}
                                                        /> : ""
                                                    }
                                                </div>
                                                {card.card && deckView === 1 && (
                                                    <p className="quantity-inline text-center"
                                                       style={{color: (card.quantity - parseInt(card.card.rank) > 0) ? 'red' : 'lightgrey'}}>{card.quantity}</p>
                                                )}
                                            </div>
                                        </div>
                                        ))
                                    : null}
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </BrowserView>
            {/* Render the CardDetails component when selectedCard is not null */}
            {selectedCard && (
                deckView === 1 ?
                    <CardDetails
                        cardDetails={{
                            ...selectedCard.card,
                            imageUrl: selectedCard.card.imageUrl ? selectedCard.card.imageUrl.replace('/EN/', '/EN/hd/') : undefined
                        }}
                        abilities={dAbilities}
                        onClose={hideCardDetails}
                        disableTopOffset={true}
                    />
                    :
                    <CardDetails
                        cardDetails={{
                            ...selectedCard,
                            imageUrl: selectedCard.imageUrl ? selectedCard.imageUrl.replace('/EN/', '/EN/hd/') : undefined
                        }}
                        abilities={abilities}
                        onClose={hideCardDetails}
                        disableTopOffset={true}
                    />
            )}

        </div>
    );
};

export default Cards;
